import moment from "moment-timezone";
import Api from "../../customlib/Api";
import { QUICK_LABELS, LIVECHAT_PARTNER_BRAND } from "./livechatConstants";

// Tone hangat/muted senada tema "Pastel Bouquet" (bukan warna Material generik) — dipakai untuk
// avatar pelanggan (hash by name), lihat livechatTheme.js untuk warna brand & aksen utama.
const AVATAR_COLORS = ["#8c5b73", "#c08a2e", "#6a8f6b", "#a1655a", "#6b7fa3", "#a3708f", "#8a9a5b", "#b3765a"];

export function getAvatarColor(name = "") {
    let hash = 0;
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash);
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

export function getInitials(name = "") {
    const parts = name.trim().split(/\s+/).filter(Boolean);
    if (parts.length === 0) return "?";
    if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
    return (parts[0][0] + parts[1][0]).toUpperCase();
}

export function getLabelColor(labelType) {
    return QUICK_LABELS.find((l) => l.label === labelType)?.color;
}

// Jenis lampiran dari mimetype file lokal — dipakai saat MEMILIH file (sebelum upload), mirror
// deteksi server-side di lotus-be-express/src/modules/livechat/utils/attachment.util.ts.
export function getAttachmentKind(mimeType = "") {
    if (mimeType.startsWith("image/")) return "image";
    if (mimeType.startsWith("video/")) return "video";
    return "document";
}

// DEV-1422 — URL foto mitra dari path aset Lavender ("/assets/images/suppliers/selfie_1.jpg", dikirim
// backend sebagai customerAvatarPath / avatarPath). Mirror lavenderAssetsUrl di app mitra
// (prestisa_supplier/src/utils/common.js): "<lavender>/api/assets/<2 segmen terakhir path>".
// Sengaja getLavenderAssetsUrl, BUKAN getLavenderUrl — di staging getLavenderUrl menunjuk
// staging.prestisa.id yang tidak punya file selfie mitra (404 -> avatar jatuh ke inisial, QA AC-4).
export function getPartnerAvatarUrl(path) {
    if (typeof path !== "string" || !path.trim()) return null;
    const base = Api.getLavenderAssetsUrl();
    if (!base) return null;
    const segments = path.replace(/\\/g, "/").split("/").filter(Boolean).slice(-2);
    return `${base.replace(/\/+$/, "")}/api/assets/${segments.join("/")}`;
}

// DEV-1422 — cadangan saja: backend sudah mengirim customerPhoneMasked untuk sesi mitra. Dipakai kalau
// payload (mis. event socket parsial) belum membawa field itu, supaya nomor lengkap mitra tidak
// sempat tampil. Format sama dengan formatMaskedPhone backend (supplierDisplay.util.ts).
export function maskPartnerPhone(raw) {
    const digits = String(raw || "").replace(/\D/g, "");
    if (!digits) return "";
    const normalized = digits.startsWith("0") ? `62${digits.slice(1)}` : digits.startsWith("62") ? digits : `62${digits}`;
    const local = normalized.slice(2);
    if (local.length <= 7) return `+62 ${local}`;
    return `+62 ${local.slice(0, 3)}-${local.slice(3, 7)}-xxxx`;
}

// DEV-1422 — nomor yang DITAMPILKAN untuk sebuah sesi: tersamar di channel mitra-purchasing, apa adanya
// di channel customer. `customerPhone` mentah tetap dipakai untuk room socket & request lain.
export function getSessionDisplayPhone(session) {
    if (!session) return "";
    if (session.brand !== LIVECHAT_PARTNER_BRAND) return session.customerPhone || "";
    return session.customerPhoneMasked || maskPartnerPhone(session.customerPhone);
}

// DEV-1421 — label pemisah tanggal di percakapan mitra-purchasing: "Hari ini" / "Kemarin" / tanggal
// lengkap ("Senin, 28 Sep 2026"). Nama hari/bulan ditulis manual (bukan locale moment "id") supaya
// tidak bergantung pada locale yang dimuat global. Zona Asia/Jakarta, sama dengan jam di bubble.
const DAY_NAMES = ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"];
const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "Mei", "Jun", "Jul", "Agu", "Sep", "Okt", "Nov", "Des"];

export function getChatDayKey(datetime) {
    if (!datetime) return null;
    const m = moment(datetime).tz("asia/jakarta");
    return m.isValid() ? m.format("YYYY-MM-DD") : null;
}

export function formatChatDayLabel(datetime, now = new Date()) {
    const day = moment(datetime).tz("asia/jakarta").startOf("day");
    const today = moment(now).tz("asia/jakarta").startOf("day");
    const diff = today.diff(day, "days");
    if (diff === 0) return "Hari ini";
    if (diff === 1) return "Kemarin";
    return `${DAY_NAMES[day.day()]}, ${day.date()} ${MONTH_NAMES[day.month()]} ${day.year()}`;
}
